import type { CryptoAsset } from "~/types/assets.types";

export const calculateCryptoYears = (userProduct: CryptoAsset) => {
  const coins = userProduct?.cryptoData || [];

  return coins.map((coin) => {
    const purchaseDate = coin.purchaseDate || "";
    const currentDate = new Date();
    const purchasingDate = new Date(purchaseDate);

    return currentDate.getFullYear() - purchasingDate.getFullYear() || 0;
  });
};
